import React, { useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import classes from "./index.module.scss";
import images from "../../resources/images";
import CustModal from "../Modal";
import { createPortal } from "react-dom";
import { useNavigate } from 'react-router-dom'

const FeaturedComponent = ({ image, children, btnText, icon, mainData, newTabLink, noModalHeader, navigation, route }) => {
	const [modalShow, setModalShow] = useState(false);
const navigate = useNavigate();
	return (
		<React.Fragment>
			<Container className={`${classes.wrapper}`} fluid>
				<img src={image} />
				<Row>
					<Col md={7} className={`px-0`}>
						{children}
						<Button className={`f-20 regular`} onClick={navigation?()=>{navigate(route)}:() =>setModalShow(true)}>
							{btnText}
						</Button>
					</Col>
					<Col md={4} style={{ alignSelf: "flex-end" }}>
						{icon}
					</Col>
				</Row>
				<CustModal newTabLink={newTabLink} show={modalShow} onHide={() => setModalShow(false)} noModalHeader={noModalHeader}>
					{mainData}
				</CustModal>
			</Container>
		</React.Fragment>
	);
};
export default FeaturedComponent;
